import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import 'primeicons/primeicons.css';
import 'primereact/resources/themes/lara-light-amber/theme.css';
import 'primereact/resources/primereact.min.css';
import '@/styles/globals.css';

import { App } from '@/app/App';
import { AppProviders } from '@/app/AppProviders';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element was not found.');
}

createRoot(rootElement).render(
  <StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </StrictMode>,
);
